import React from 'react';
import Button from '@material-ui/core/Button';
import Grid from '@material-ui/core/Grid';
import {StandartInput} from '@components/form/StandartInput';
import RemoteAutocompleteSelect from '@components/form/RemoteAutocompleteSelect';
import {Select} from '@components/form/Select';
import FormLabel from '@material-ui/core/FormLabel';
import {InputPhone} from '@components/form/InputPhone';
import {SimpleDialog} from "@components/form/SimpleDialog";
import ResponsiveComponent from "@components/form/ResponsiveComponent";
import {PopoverComponent} from '@components/form/PopoverComponent';
import InputAdornment from "@material-ui/core/InputAdornment";
import RemoteAutocompleteWithSearch from '@components/form/RemoteAutocompleteWithSearch';
import {Price} from '~/components/form/formatting/Price';

import * as Enum from './enum/constants';
import {history} from '~/router/history';
import {empty} from '~/utils/empty';
import debounce from 'lodash/debounce';
import * as dayjs from 'dayjs';
const merge = require('deepmerge');
import clsx from 'clsx';

export class NewTtnComponent extends React.Component {
    state = {
        open: false,
        config: {
            api_key: ''
        },
        configs: [],
        activeConfig: "0",
        configLoaded: false,
        form: {
            PayerType: this.props.PayerType || Enum.deliveryPayers[1].value,
            PaymentMethod: this.props.PaymentMethod || Enum.paymentForm[1].value,
            DateTime: '',
            CargoType: this.props.CargoType || Enum.cargoType[0].value,
            Weight: this.props.Weight || 0.5,
            VolumeGeneral: this.props.CargoType || 0.004,
            ServiceType: this.props.ServiceType || Enum.deliveryTypes[0].value,
            SeatsAmount: this.props.SeatsAmount || 1,
            Description: this.props.Description || '',
            Cost: this.props.Cost,

            Sender: '',
            CitySender: '',
            SenderAddress: '',
            ContactSender: '',
            SendersPhone: '',

            // Recipient: '',
            CityRecipient: '',
            CityRecipientName: '',
            RecipientAddress: '',
            RecipientAddressName: '',
            ContactRecipient: this.props.ContactRecipient || '',
            RecipientsPhone: this.props.RecipientsPhone || '',

            BackwardDeliveryData: {
                PayerType: this.props.BackwardDeliveryPayerType || Enum.deliveryPayers[1].value, //Recipient
                CargoType: this.props.BackwardDeliveryCargoType || Enum.backwardCargoType[1].value, //Money
                RedeliveryString: this.props.Cost || 0, //uah
            },
            DoorsDelivery: {
                RecipientStreetRef: '',
                RecipientHouse: '',
                RecipientFlat: '',
            },

            RedBoxBarcode: '',
            VolumeWeight: {
                width: 0,
                height: 0,
                length: 0,
            },
        },
        deliveryInfo: {
            date: '',
            cost: ''
        },
        isValidate: false,
        errors: {}
    };

    async componentDidUpdate(prevProps, prevState) {
        if (this.state.open && this.state.open !== prevState.open) {
            const config = await this.props.getModulesConfiguration();
            const response = await this.props.getOrderDetails(this.props.order_id);
            this.setState({
                configs: config.data.cabinets,
                config: config.data.cabinets[0],
                configLoaded: true,
                isValidate: this.validate(),
            });
            this.setConfig(config.data.cabinets[0], response.data.delivery_details_novaposhta);
        }
        if(this.state.open && this.validate() !== this.state.isValidate) {
            this.setState({
                ...this.state,
                isValidate: this.validate(),
            })
        }
        if(this.state.open && prevState.isValidate !== this.state.isValidate) {
            if(this.state.isValidate) {
                let date = await this.props.getDeliveryDate({
                    ...this.state.form,
                    api_key: this.state.config.api_key,
                });
                let cost = await this.props.getDeliveryCost({
                    ...this.state.form,
                    api_key: this.state.config.api_key,
                });
                if (date.errors) {
                    this.setState({errors: date.errors});
                }
                if (cost.errors) {
                    this.setState({errors: cost.errors});
                }
                if (date.data && cost.data) {
                    this.setState({
                        ...this.state,
                        deliveryInfo: {
                            date: date.data.date,
                            cost: cost.data.cost,
                        },
                        errors: {},
                        isValidate: true
                    })
                }
            } else {
                this.setState({
                    ...this.state,
                    deliveryInfo: {
                        date: '',
                        cost: ''
                    },
                    isValidate: false
                })
            }
        }
    }

    setConfig = (config, delivery_details_novaposhta) => {
        if (config) {
            this.setState({
                config,
                form: {
                    ...this.state.form,
                    Sender: config.Sender,
                    CitySender: config.CitySender,
                    SenderAddress: config.SenderAddress,
                    SenderAddressName: config.SenderAddressName,
                    ContactSender: config.ContactSender,
                    SendersPhone: config.SendersPhone,

                    CargoType: config.CargoType,
                    PayerType: config.PayerType,
                    PaymentMethod: config.PaymentMethod,
                    ServiceType: config.ServiceType,
                    Description: config.Description || '',

                    BackwardDeliveryData: {
                        ...this.state.form.BackwardDeliveryData,
                        CargoType: config.BackwardDeliveryCargoType,
                        PayerType: config.BackwardDeliveryPayerType,
                        Type: config.BackwardDeliveryPaymentType || Enum.backwardPaymentType[0].value,
                    }
                }
            });
        }
        if (delivery_details_novaposhta) {
            this.setState({
                config,
                form: {
                    ...this.state.form,
                    CityRecipient: delivery_details_novaposhta.CityRecipient,
                    CityRecipientName: delivery_details_novaposhta.CityRecipientName,
                    RecipientAddress: delivery_details_novaposhta.RecipientAddress,
                    RecipientAddressName: delivery_details_novaposhta.RecipientAddressName,
                    ContactRecipient: delivery_details_novaposhta.ContactRecipient,
                    RecipientsPhone: delivery_details_novaposhta.RecipientsPhone,
                    Description: delivery_details_novaposhta.Description || ''
                }
            });
        }
    }

    createTtn = () => {
        this.props.createTtn(this.state.config.api_key, this.state.form, this.props.order_id).then((data) => {
            if (data.errors) {
                this.setState({errors: data.errors});
            } else {
                if (data.data.ref) {
                    this.setState({open: false});
                    if (this.props.onSubmitRedirect) {
                        this.props.onSubmitRedirect(data);
                    } else {
                        history.go();
                    }
                }
            }
        });
    }

    validate = () => {
        let fields = ['DateTime', 'ServiceType', 'CitySender', 'CityRecipient', 'ContactRecipient', 'RecipientsPhone', 'Weight', 'SeatsAmount', 'Cost', 'Description'];
        if (this.state.form.ServiceType === 'WarehouseWarehouse')
            fields.push('RecipientAddress');
        else
            fields.push('DoorsDelivery.RecipientStreetRef', 'DoorsDelivery.RecipientHouse', 'DoorsDelivery.RecipientFlat');
        let {form} = this.state;
        return !fields.some(function(field) {
            if(field.indexOf('.') !== -1) {
                let subfields = field.split('.');
                return empty(form[subfields[0]][subfields[1]]);
            }
            return empty(form[field]);
        });
    }

    componentDidMount() {
        this.setState({form: {
            ...this.state.form,
            DateTime: this.generateDeliveryDateRange()[0].value
        }})
    }

    generateDeliveryDateRange = () => {
        const today = (new Date());
        const isTodayDeliveryAvailable = today.getHours() < 18;
        let dateOptions = [];
        if (isTodayDeliveryAvailable) {
            dateOptions.push({
                value: dayjs().format('DD.MM.YYYY'),
                label: `${dayjs().format('DD.MM.YYYY')} (cегодня)`
            })
            dateOptions.push({
                value: dayjs().add(1, 'day').format('DD.MM.YYYY'),
                label: `${dayjs().add(1, 'day').format('DD.MM.YYYY')} (завтра)`
            })
            dateOptions.push({
                value: dayjs().add(2, 'day').format('DD.MM.YYYY'),
                label: `${dayjs().add(2, 'day').format('DD.MM.YYYY')} (послезавтра)`
            })
        } else {
            dateOptions.push({
                value: dayjs().add(1, 'day').format('DD.MM.YYYY'),
                label: `${dayjs().add(1, 'day').format('DD.MM.YYYY')} (завтра)`
            })
            dateOptions.push({
                value: dayjs().add(2, 'day').format('DD.MM.YYYY'),
                label: `${dayjs().add(2, 'day').format('DD.MM.YYYY')} (послезавтра)`
            })
            dateOptions.push({
                value: dayjs().add(3, 'day').format('DD.MM.YYYY'),
                label: `${dayjs().add(3, 'day').format('DD.MM.YYYY')}`
            })
        }

        return dateOptions;
    }

    updateValidationDebounce = debounce((data) => {
        this.setState(merge(this.state, { isValidate: false }));
    }, 600);

    validateAutocompleteSearchInput = (e, name) => {
        let value = e?.target.value;
        let { errors } = this.state;
        if (value && !/[а-я0-9]/i.test(e.target.value)) {
            this.setState({...this.state, errors: {[name]: ['Проверьте язык написания']}});
            return false;
        } else if (errors.hasOwnProperty(name)) {
            delete errors[name];
            this.setState({...this.state, errors: errors});
        }
        return true;
    };

    render() {
        let { classes } = this.props;
        let {deliveryInfo} = this.state;

        return (
            <SimpleDialog
                fullWidth={true}
                maxWidth={'lg'}
                open={this.state.open}
                onClose={(e) => this.setState({open: false})}
                title={<>
                    Создание ТТН Новой Почты
                    <ResponsiveComponent
                        xs={<br />}
                        md={<></>}
                    />
                    <span className={classes.subtitle}>
                        – доставка
                        {!deliveryInfo.date && !deliveryInfo.cost
                            ? ' не рассчитана'
                            : <> {dayjs(deliveryInfo.date).format('DD.MM.YYYY')} (<Price value={deliveryInfo.cost}/>)</>}
                    </span>
                </>}
                icon={<Button
                    onClick={(e) => {
                        e.preventDefault();
                        e.stopPropagation();
                        this.setState({open: true})
                    }}
                    variant="outlined"
                    color="primary"
                >
                    ТТН
                </Button>}
                actions={[
                    (<Button
                        onClick={(e) => {
                            e.stopPropagation();
                            this.createTtn(this.props.rowIndex, this.state.form);
                        }}
                        color="primary" variant="contained"
                    >
                        Сохранить
                    </Button>),
                ]}
            >
                {this.state.configLoaded ? <>
                    {this.state.configs.length > 1 ? (<Grid container spacing={3} className={classes.gridContainer}>
                        <Grid item xs={12} md={6}>
                            <Select
                                options={this.state.configs.map((row, i) => {
                                    return {
                                        value: i,
                                        label: row.name,
                                    }
                                })}
                                value={this.state.activeConfig}
                                displayEmpty={false}
                                onChange={({target: {value}}) => {
                                    this.setState({...this.state, activeConfig: value})
                                    this.setConfig(this.state.configs[value])
                                }}
                                className={clsx([
                                    classes.input,
                                    classes.resetInputMarginTop,
                                ])}
                                variant={'outlined'}
                                margin={'normal'}
                                size={'small'}
                                fullWidth
                            />
                        </Grid>
                        <Grid item xs={12} md={6}></Grid>
                    </Grid>) : null}

                    <Grid container spacing={3} className={classes.gridContainer}>
                        <Grid item xs={12} md={6}>
                            <FormLabel
                                component="legend"
                                className={classes.newTTN_formLabel}
                                style={{marginTop: this.state.configs.length > 1 ? '30px' : '0px'}}
                            >Отправитель</FormLabel>

                            <RemoteAutocompleteSelect
                                name={'Sender'}
                                url={'/api/v1/modules/novaposhta/autocomplete/counterparty/sender-list?api_key=' + this.state.config.api_key}
                                value={this.state.form.Sender}
                                errors={this.state.errors}
                                label="Контрагент"
                                onChange={(e, {value}) => this.setState(merge(this.state, {form: {Sender: value}}))}
                                disableClearable={true}
                                fillFirst={true}
                                className={classes.input}
                                variant={'outlined'}
                                margin={'normal'}
                                size={'small'}
                                fullWidth
                            />
                            <RemoteAutocompleteSelect
                                name={'ContactSender'}
                                url={this.state.form.Sender ? '/api/v1/modules/novaposhta/autocomplete/counterparty/sender-contacts?Ref=' + this.state.form.Sender + '&api_key=' + this.state.config.api_key : ''}
                                value={this.state.form.ContactSender}
                                errors={this.state.errors}
                                label="ФИО отправителя"
                                onChange={(e, {value, phone}) => this.setState(merge(this.state, {form: {ContactSender: value, SendersPhone: phone}}))}
                                disableClearable={true}
                                fillFirst={true}
                                className={classes.input}
                                variant={'outlined'}
                                margin={'normal'}
                                size={'small'}
                                fullWidth
                            />
                            <RemoteAutocompleteWithSearch
                                name={'CitySender'}
                                url={'/api/v1/modules/novaposhta/autocomplete/address/city?api_key=' + this.state.config.api_key}
                                initOnRuntime
                                initialValue={{
                                    value: this.state.config.CitySender,
                                    label: this.state.config.CitySenderName,
                                }}

                                searchFieldName={'CityName'}
                                label="Населенный пункт"
                                onChange={(e, target) => this.setState(merge(this.state, {isValidate: false, form: {
                                        CitySender: target?.value
                                    }}))}
                                className={classes.input}
                                variant={'outlined'}
                                margin={'normal'}
                                size={'small'}
                                fullWidth
                            />
                            <RemoteAutocompleteWithSearch
                                name={'SenderAddress'}
                                initOnRuntime
                                initialValue={{
                                    value: this.state.form.SenderAddress,
                                    label: this.state.form.SenderAddressName,
                                }}
                                url={this.state.form.CitySender
                                    ? '/api/v1/modules/novaposhta/autocomplete/address/warehouse?CityRef=' + this.state.form.CitySender + '&api_key=' + this.state.config.api_key
                                    : ''}
                                searchFieldName={'FindByString'}
                                value={this.state.form.SenderAddress}
                                errors={this.state.errors}
                                label="Отделение"
                                onChange={(e, obj) => this.setState(merge(this.state, {form: {SenderAddress: obj && obj.value ? obj.value : ''}}))}
                                disableClearable={false}
                                className={classes.input}
                                variant={'outlined'}
                                margin={'normal'}
                                size={'small'}
                                fullWidth
                            />
                            <InputPhone
                                name={'SendersPhone'}
                                value={this.state.form.SendersPhone}
                                errors={this.state.errors}
                                label="Телефон отправителя"
                                onChange={(phone) => this.setState(merge(this.state, {form: {SendersPhone: phone}}))}
                                className={classes.input}
                                variant={'outlined'}
                                margin={'normal'}
                                size={'small'}
                                fullWidth
                            />

                            <FormLabel
                                component="legend"
                                className={classes.newTTN_formLabel}
                            >Оплата</FormLabel>

                            <Select
                                name={'ServiceType'}
                                value={this.state.form.ServiceType}
                                options={Enum.deliveryTypes}
                                displayEmpty={false}
                                label="Технология доставки"
                                className={classes.input}
                                variant={'outlined'}
                                margin={'normal'}
                                size={'small'}
                                fullWidth
                                onChange={({target: {value}}) => this.setState(merge(this.state,{isValidate: false, form: {ServiceType: value}}))}
                            />
                            <Grid container spacing={3} className={classes.gridSubContainer_row2}>
                                <Grid item xs={12} lg={6}>
                                    <Select
                                        name={'PayerType'}
                                        value={this.state.form.PayerType}
                                        options={Enum.deliveryPayers}
                                        displayEmpty={false}
                                        label="Плательщик отправления"
                                        className={classes.input}
                                        variant={'outlined'}
                                        margin={'normal'}
                                        size={'small'}
                                        fullWidth
                                        onChange={({target: {value}}) => this.setState(merge(this.state,{form: {PayerType: value}}))}
                                    />
                                </Grid>
                                <Grid item xs={12} lg={6}>
                                    <Select
                                        name={'PayerType'}
                                        value={this.state.form.BackwardDeliveryData.PayerType}
                                        options={Enum.deliveryPayers}
                                        displayEmpty={false}
                                        label="Плательщик обратной доставки"
                                        className={classes.input}
                                        variant={'outlined'}
                                        margin={'normal'}
                                        size={'small'}
                                        fullWidth
                                        onChange={({target: {value}}) => this.setState(merge(this.state,{form: {BackwardDeliveryData: {PayerType: value}}}))}
                                    />
                                </Grid>
                            </Grid>
                            <Select
                                name={'PaymentMethod'}
                                value={this.state.form.PaymentMethod}
                                options={Enum.paymentForm}
                                displayEmpty={false}
                                label="Форма оплаты"
                                className={classes.input}
                                variant={'outlined'}
                                margin={'normal'}
                                size={'small'}
                                fullWidth
                                onChange={({target: {value}}) => this.setState(merge(this.state,{form: {PaymentMethod: value}}))}
                            />
                            <Select
                                name={'DateTime'}
                                value={this.state.form.DateTime}
                                options={this.generateDeliveryDateRange()}
                                displayEmpty={false}
                                label="Дата отправки"
                                className={classes.input}
                                variant={'outlined'}
                                margin={'normal'}
                                size={'small'}
                                fullWidth
                                onChange={({target: {value}}) => this.setState(merge(this.state,{isValidate: false, form: {DateTime: value}}))}
                            />
                        </Grid>

                        <Grid item xs={12} md={6}>
                            <FormLabel
                                className={clsx([classes.newTTN_formLabel, classes.formLabel_margin_sm])}
                                style={{marginTop: this.state.configs.length > 1 ? '30px' : '0px'}}
                                component="legend"
                            >Получатель</FormLabel>

                            <StandartInput
                                name={'ContactRecipient'}
                                value={this.state.form.ContactRecipient}
                                errors={this.state.errors}
                                label="ФИО получателя"
                                onChange={({target: {value}}) => {
                                    this.setState(merge(this.state, {form: {ContactRecipient: value}}));
                                    this.updateValidationDebounce();
                                }}
                                className={classes.input}
                                variant={'outlined'}
                                margin={'normal'}
                                size={'small'}
                                fullWidth
                            />
                            <InputPhone
                                name={'RecipientsPhone'}
                                value={this.state.form.RecipientsPhone}
                                errors={this.state.errors}
                                label="Телефон получателя"
                                onChange={(phone) => this.setState(merge(this.state, {form: {RecipientsPhone: phone}}))}
                                className={classes.input}
                                variant={'outlined'}
                                margin={'normal'}
                                size={'small'}
                                fullWidth
                            />
                            <RemoteAutocompleteWithSearch
                                name={'CityRecipient'}
                                autoFocus
                                initOnRuntime
                                initialValue={{
                                    value: this.state.form.CityRecipient,
                                    label: this.state.form.CityRecipientName,
                                }}
                                value={this.state.form.CityRecipient}
                                errors={this.state.errors}
                                url={'/api/v1/modules/novaposhta/autocomplete/address/city?api_key=' + this.state.config.api_key}
                                searchFieldName={'CityName'}
                                label="Населенный пункт"
                                onChange={(e, target) => this.setState(merge(this.state, {isValidate: false, form: {CityRecipient: target?.value, CityRecipientName: target?.label}}))}
                                validateSearchInput={this.validateAutocompleteSearchInput}
                                className={classes.input}
                                variant={'outlined'}
                                margin={'normal'}
                                size={'small'}
                                fullWidth
                            />
                            { this.state.form.ServiceType === 'WarehouseWarehouse'
                                ? (<RemoteAutocompleteWithSearch
                                    name={'RecipientAddress'}
                                    initOnRuntime
                                    initialValue={{
                                        value: this.state.form.RecipientAddress,
                                        label: this.state.form.RecipientAddressName,
                                    }}
                                    url={this.state.form.CityRecipient
                                        ? '/api/v1/modules/novaposhta/autocomplete/address/warehouse?CityRef=' + this.state.form.CityRecipient + '&api_key=' + this.state.config.api_key
                                        : ''
                                    }
                                    searchFieldName={'FindByString'}
                                    value={this.state.form.RecipientAddress}
                                    errors={this.state.errors}
                                    label="Отделение"
                                    onChange={(e, target) => this.setState(merge(this.state, {form: {RecipientAddress: target?.value, RecipientAddressName: target?.label}}))}
                                    disableClearable={false}
                                    className={classes.input}
                                    variant={'outlined'}
                                    margin={'normal'}
                                    size={'small'}
                                    fullWidth
                                />) : (
                                    <Grid container spacing={3} className={classes.gridSubContainer_StreetRef}>
                                        <Grid item xs={12} lg={4}>
                                            <RemoteAutocompleteWithSearch
                                                name={'RecipientStreetRef'}
                                                url={this.state.form.CityRecipient
                                                    ? '/api/v1/modules/novaposhta/autocomplete/address/street?CityRef=' + this.state.form.CityRecipient + '&api_key=' + this.state.config.api_key
                                                    : ''
                                                }
                                                searchFieldName={'FindByString'}
                                                value={this.state.form.DoorsDelivery.RecipientStreetRef}
                                                errors={this.state.errors}
                                                errorSubKey={'DoorsDelivery'}
                                                classWrapperName={'row3'}
                                                label="Улица"
                                                onChange={(e, obj) => this.setState(merge(this.state, {form: {DoorsDelivery: {RecipientStreetRef: obj && obj.value ? obj.value : ''}}}))}
                                                disableClearable={false}
                                                initOnRuntime
                                                className={classes.input}
                                                variant={'outlined'}
                                                margin={'normal'}
                                                size={'small'}
                                                fullWidth
                                            />
                                        </Grid>
                                        <Grid item xs={12} sm={6} lg={4}>
                                            <StandartInput
                                                name={'RecipientHouse'}
                                                value={this.state.form.DoorsDelivery.RecipientHouse}
                                                errors={this.state.errors}
                                                errorSubKey={'DoorsDelivery'}
                                                label="Дом"
                                                onChange={({target: {value}}) => this.setState(merge(this.state, {form: {DoorsDelivery: {RecipientHouse: value}}}))}
                                                className={classes.input}
                                                variant={'outlined'}
                                                margin={'normal'}
                                                size={'small'}
                                                fullWidth
                                            />
                                        </Grid>
                                        <Grid item xs={12} sm={6} lg={4}>
                                            <StandartInput
                                                name={'RecipientFlat'}
                                                value={this.state.form.DoorsDelivery.RecipientFlat}
                                                errors={this.state.errors}
                                                errorSubKey={'DoorsDelivery'}
                                                label="Квартира"
                                                onChange={({target: {value}}) => this.setState(merge(this.state, {form: {DoorsDelivery: {RecipientFlat: value}}}))}
                                                className={classes.input}
                                                variant={'outlined'}
                                                margin={'normal'}
                                                size={'small'}
                                                fullWidth
                                            />
                                        </Grid>
                                    </Grid>
                                )
                            }
                            <StandartInput
                                name={'Description'}
                                value={this.state.form.Description}
                                errors={this.state.errors}
                                label="Описание груза"
                                onChange={({target: {value}}) => {
                                    this.setState(merge(this.state, {form: {Description: value}}));
                                    this.updateValidationDebounce();
                                }}
                                className={classes.input}
                                variant={'outlined'}
                                margin={'normal'}
                                size={'small'}
                                fullWidth
                            />

                            <FormLabel component="legend" className={classes.newTTN_formLabel}>Груз</FormLabel>

                            <Select
                                name={'CargoType'}
                                value={this.state.form.CargoType}
                                options={Enum.cargoType}
                                displayEmpty={false}
                                label="Тип груза"
                                className={classes.input}
                                variant={'outlined'}
                                margin={'normal'}
                                size={'small'}
                                fullWidth
                                onChange={({target: {value}}) => this.setState(merge(this.state,{form: {CargoType: value}}))}
                            />

                            <Grid container spacing={3} className={classes.gridSubContainer_row3}>
                                <Grid item xs={12} md={4}>
                                    <StandartInput
                                        name={'width'}
                                        value={this.state.form.VolumeWeight.width}
                                        errors={this.state.errors}
                                        errorSubKey={'VolumeWeight'}
                                        className={classes.input}
                                        variant={'outlined'}
                                        margin={'normal'}
                                        size={'small'}
                                        fullWidth
                                        label="Ширина"
                                        onChange={({target: {value}}) => this.setState(merge(this.state, {form: {VolumeWeight: {width: value}}}))}
                                        InputProps={{
                                            startAdornment: (<InputAdornment position="start">см</InputAdornment>),
                                        }}
                                    />
                                </Grid>
                                <Grid item xs={12} md={4}>
                                    <StandartInput
                                        name={'length'}
                                        value={this.state.form.VolumeWeight.length}
                                        errors={this.state.errors}
                                        errorSubKey={'VolumeWeight'}
                                        className={classes.input}
                                        variant={'outlined'}
                                        margin={'normal'}
                                        size={'small'}
                                        fullWidth
                                        label="Длина"
                                        onChange={({target: {value}}) => this.setState(merge(this.state, {form: {VolumeWeight: {length: value}}}))}
                                        InputProps={{
                                            startAdornment: (<InputAdornment position="start">см</InputAdornment>),
                                        }}
                                    />
                                </Grid>
                                <Grid item xs={12} md={4}>
                                    <StandartInput
                                        name={'height'}
                                        value={this.state.form.VolumeWeight.height}
                                        errors={this.state.errors}
                                        errorSubKey={'VolumeWeight'}
                                        className={classes.input}
                                        variant={'outlined'}
                                        margin={'normal'}
                                        size={'small'}
                                        fullWidth
                                        label="Высота"
                                        onChange={({target: {value}}) => this.setState(merge(this.state, {form: {VolumeWeight: {height: value}}}))}
                                        InputProps={{
                                            startAdornment: (<InputAdornment position="start">см</InputAdornment>),
                                        }}
                                    />
                                </Grid>
                            </Grid>

                            <Grid container spacing={3} className={classes.gridSubContainer_row3}>
                                <Grid item xs={12} md={4}>
                                    <StandartInput
                                        name={'Weight'}
                                        value={this.state.form.Weight}
                                        errors={this.state.errors}
                                        className={classes.input}
                                        variant={'outlined'}
                                        margin={'normal'}
                                        size={'small'}
                                        fullWidth
                                        label="Общий вес"
                                        onChange={({target: {value}}) => this.setState(merge(this.state,{isValidate: false, form: {Weight: value}}))}
                                        InputProps={{
                                            startAdornment: (<InputAdornment position="start">кг</InputAdornment>),
                                        }}
                                    />
                                </Grid>
                                <Grid item xs={12} md={4}>
                                    <StandartInput
                                        name={'VolumeGeneral'}
                                        value={this.state.form.VolumeGeneral}
                                        errors={this.state.errors}
                                        className={classes.input}
                                        variant={'outlined'}
                                        margin={'normal'}
                                        size={'small'}
                                        fullWidth
                                        label="Объемный вес"
                                        onChange={({target: {value}}) => this.setState(merge(this.state,{form: {VolumeGeneral: value}}))}
                                        InputProps={{
                                            startAdornment: (<InputAdornment position="start">кг</InputAdornment>),
                                        }}
                                    />
                                </Grid>
                                <Grid item xs={12} md={4}>
                                    <StandartInput
                                        name={'SeatsAmount'}
                                        value={this.state.form.SeatsAmount}
                                        errors={this.state.errors}
                                        className={classes.input}
                                        variant={'outlined'}
                                        margin={'normal'}
                                        size={'small'}
                                        fullWidth
                                        label="Мест"
                                        onChange={({target: {value}}) => this.setState(merge(this.state,{isValidate: false, form: {SeatsAmount: value}}))}
                                        InputProps={{
                                            startAdornment: (<InputAdornment position="start">ед.</InputAdornment>),
                                        }}
                                    />
                                </Grid>
                            </Grid>

                            <Grid container spacing={3} className={classes.gridSubContainer_costs}>
                                <ResponsiveComponent
                                    xs={<></>}
                                    md={<Grid item xs={12}>
                                        <Select
                                            name={'CargoType'}
                                            value={this.state.form.BackwardDeliveryData.CargoType}
                                            options={Enum.backwardCargoType}
                                            errorSubKey={'BackwardDeliveryData'}
                                            displayEmpty={false}
                                            label="Обратная доставка"
                                            className={classes.input}
                                            variant={'outlined'}
                                            margin={'normal'}
                                            size={'small'}
                                            fullWidth
                                            onChange={({target: {value}}) => this.setState(merge(this.state,{form: {BackwardDeliveryData: {CargoType: value}}}))}
                                        />
                                    </Grid>}
                                    lg={<></>}
                                />

                                <Grid item xs={12} md={6} lg={4}>
                                    <div style={{width: '100%'}}>
                                        <StandartInput
                                            name={'Cost'}
                                            value={this.state.form.Cost}
                                            errors={this.state.errors}
                                            errorSubKey={'Cost'}
                                            className={classes.input}
                                            variant={'outlined'}
                                            margin={'normal'}
                                            size={'small'}
                                            fullWidth
                                            label="Оценочная стоимость"
                                            onChange={({target: {value}}) => this.setState(merge(this.state,{isValidate: false, form: {Cost: value}}))}
                                        />
                                        {this.state.config.BackwardDeliveryRedeliveryString && <div className={classes.selectCost_box}>
                                            <div className={classes.selectCost_costs}>
                                                Выбрать:
                                                <span
                                                    onClick={() => this.setState(merge(this.state,{isValidate: false, form: {Cost: this.state.config.BackwardDeliveryRedeliveryString}}))}
                                                >{this.state.config.BackwardDeliveryRedeliveryString}</span>
                                                <span
                                                    onClick={() => this.setState(merge(this.state,{isValidate: false, form: {Cost: this.props.Cost}}))}
                                                >{this.props.Cost}</span>
                                            </div>
                                            <PopoverComponent
                                                text={'В качестве оценочной стоимости вы можете выбрать установленую в конфигурации кабинета стоимость (первое чисто), стоимость заказа (второе чисто), или же прописать свою стоимость в поле выше.'}
                                                iconProps={{
                                                    size: 'small',
                                                    style: {
                                                        color: '#9e9e9e',
                                                        padding: '2px 0px 0px 5px',
                                                        width: '13px',
                                                        height: '13px',
                                                    },
                                                }}
                                            />
                                        </div>}
                                    </div>
                                </Grid>

                                <ResponsiveComponent
                                    xs={<Grid item xs={12} lg={4}>
                                        <Select
                                            name={'CargoType'}
                                            value={this.state.form.BackwardDeliveryData.CargoType}
                                            options={Enum.backwardCargoType}
                                            errorSubKey={'BackwardDeliveryData'}
                                            displayEmpty={false}
                                            label="Обратная доставка"
                                            className={classes.input}
                                            variant={'outlined'}
                                            margin={'normal'}
                                            size={'small'}
                                            fullWidth
                                            onChange={({target: {value}}) => this.setState(merge(this.state,{form: {BackwardDeliveryData: {CargoType: value}}}))}
                                        />
                                    </Grid>}
                                    md={<></>}
                                    lg={<Grid item xs={12} lg={4}>
                                        <Select
                                            name={'CargoType'}
                                            value={this.state.form.BackwardDeliveryData.CargoType}
                                            options={Enum.backwardCargoType}
                                            errorSubKey={'BackwardDeliveryData'}
                                            displayEmpty={false}
                                            label="Обратная доставка"
                                            className={classes.input}
                                            variant={'outlined'}
                                            margin={'normal'}
                                            size={'small'}
                                            fullWidth
                                            onChange={({target: {value}}) => this.setState(merge(this.state,{form: {BackwardDeliveryData: {CargoType: value}}}))}
                                        />
                                    </Grid>}
                                />

                                <Grid item xs={12} md={6} lg={4}>
                                    <StandartInput
                                        name={'RedeliveryString'}
                                        value={this.state.form.BackwardDeliveryData.RedeliveryString}
                                        errors={this.state.errors}
                                        errorSubKey={'BackwardDeliveryData'}
                                        className={classes.input}
                                        variant={'outlined'}
                                        margin={'normal'}
                                        size={'small'}
                                        fullWidth
                                        label="Сумма"
                                        onChange={({target: {value}}) => this.setState(merge(this.state,{isValidate: false, form: {BackwardDeliveryData: {RedeliveryString: value}}}))}
                                    />
                                </Grid>
                            </Grid>

                        </Grid>
                    </Grid>
                </> : null}
            </SimpleDialog>
        );
    }
}
